import React,{useContext} from 'react'
import { VfContext } from './VfContext';

import Char1 from "./imgs/char1.png";
import Char2 from "./imgs/char2.png";

const Final = ({ acertadas, total, volverJugarBoton, deTexto, messages }) => {
    const { size } = useContext(VfContext);

    const charStyle1 = {
        backgroundImage: `url(${Char1})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPositionX: '100%',
        backgroundPositionY: '100%',
        right: '4vw'
      }

    const charStyle2 = {
        backgroundImage: `url(${Char2})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPositionX: '0%',
        backgroundPositionY: '100%',
        left: '4vw'
    }

    const pageSize = {
        height: `${size[1]}px`
      }

    const message = (acertadas) => {
        if (acertadas === total){
            return messages[2];
        }
        else if (acertadas < total && acertadas > total * 0.5){
            return messages[1];
        }
        else if (acertadas < total * 0.5){
            return messages[0];
        }
    }

    const reload = () => {
        window.location.reload(false);
      }

  return (
    <div className='final-page' style={ pageSize }>
        <div className='char izquierda' style={ charStyle1 }></div>
        <div className='char derecha' style={ charStyle2 }></div>
        <div className='final-info'>
          <p className="final-message">{ message(acertadas) }</p>
          <p className='marcador'> { `${acertadas} ${deTexto} ${total}` }</p>
          <div className='btn-container'>
            <button onClick={ reload }>{ volverJugarBoton }</button>
          </div>
        </div>
    </div>
  )
}

export default Final